



















































































































interface ReconciliationInfo {
    LJZJ: boolean;
    PromptMessage: string;
    ZCYZ: boolean;
    gdzc: string;
    ljzj: string;
    originalValue: string;
    totalDepreciate: string;
    endRemainder: string;
    longNeedDepreciate: string;
    differenceValue: string;
}
import AccountingSystem from "@/data/AccountingSystem";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class Reconciliation extends Vue {
    @Prop({ type: String })
    period?: string;

    @Prop({ type: Number })
    assetType!: number;

    checkAccountData: ReconciliationInfo | null = null;

    isNpo = this.$store.state.accountBook.accountingSystem === AccountingSystem.npo;
    created() {
        this.checkAccount()
    }
    //对账
    checkAccount() {
        Vue.axios
            .post(`fixedassets/` + this.$store.state.accountBook.id + `/reconciliation`, {
                endPeriod: this.period,
                assetType: this.assetType
            })
            .then(res => {
                this.checkAccountData = res.data
            });
    }

}
